import { z } from "zod";

// Invite-accept: the invitee sets a password + completes their profile (passport-web /accept-invite →
// POST /auth/invite/accept). token = 32-byte base64url (43 chars), same as the reset token; password
// matches register/reset (min 12). first/last are REQUIRED + non-blank (prefilled from the invite; the
// server derives display_name = "{first} {last}" — sc-89494). The 6 address fields are nullable+optional
// and mirror update-account-request (V006 column lengths); an empty field is sent as `null`.
export const acceptInviteRequestSchema = z.object({
  token: z.string().regex(/^[A-Za-z0-9_-]{43}$/, "Invalid invite token"),
  password: z.string().min(12, "Password must be at least 12 characters"),
  first_name: z.string().min(1, "First name is required").max(100).regex(/\S/, "First name cannot be blank"),
  last_name: z.string().min(1, "Last name is required").max(100).regex(/\S/, "Last name cannot be blank"),
  address_line1: z.string().max(200).nullable().optional(),
  address_line2: z.string().max(200).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  region: z.string().max(100).nullable().optional(),
  postal_code: z.string().max(20).nullable().optional(),
  country: z.string().length(2).nullable().optional(),
});
